import React from 'react';
import { Sparkles, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

const PreAuctionPremiumBanner: React.FC = () => {
  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 'auto', opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="relative overflow-hidden"
    >
      <div className="bg-gradient-to-r from-emerald-600 via-teal-500 to-emerald-600 border-b border-emerald-400/20 shadow-xl">
        {/* Animated background elements */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-teal-200 rounded-full blur-3xl" />
        </div>
        
        {/* Sparkle decorations */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <Sparkles className="absolute top-2 left-[10%] h-4 w-4 text-white/30" />
          <Sparkles className="absolute top-3 right-[15%] h-3 w-3 text-white/40" />
          <Sparkles className="absolute bottom-2 left-[30%] h-3 w-3 text-white/30" />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="py-3 sm:py-4">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center sm:text-left">
              {/* Icon */}
              <div className="hidden sm:flex items-center justify-center">
                <div className="h-10 w-10 rounded-xl bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center shadow-lg">
                  <Clock className="h-5 w-5 text-white" />
                </div>
              </div>
              
              {/* Main Message */}
              <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
                <div className="flex items-center gap-2">
                  <span className="text-white font-bold text-base sm:text-lg tracking-wide">
                    Bid Before the Auction!
                  </span>
                </div>
                
                <div className="hidden sm:block w-px h-6 bg-white/30" />
                
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-1 px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm border border-white/30">
                    <span className="text-white font-bold text-sm sm:text-base">
                      Save 50%
                    </span>
                    <span className="text-white/50 mx-1">|</span>
                    <span className="text-white font-semibold text-sm sm:text-base">
                      Exclusive 10% Buyer's Premium
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default PreAuctionPremiumBanner;

